import {FaqSection} from '@/Components/HelpModal/types';

export const CLASSROOM_HELP_SECTIONS: FaqSection[] = [
  {
    id: 'audio',
    title: 'Audio Issues',
    emoji: '🔊',
    items: [
      {
        id: 'audio-not-working',
        question: "I can't hear or speak in the class",
        blocks: [
          {
            type: 'list',
            ordered: true,
            items: [
              "Click 'Join audio by computer' if you haven't already.",
              'Allow microphone and speaker permissions when the browser asks. If you dismissed the prompt, click the settings in the address bar and set Microphone to Allow, then reload the page.',
              'Plug in or connect a headphone — built-in laptop speakers sometimes fail to switch.',
              'Test your speakers by playing any YouTube video. If that is silent too, the issue is system-level (check OS volume and output device).',
              'In masterclasses, only the host or panelist can enable your mic.',
            ],
          },
          {
            type: 'image',
            src: require('@/Assets/Images/Help/Classroom/permissions.png'),
            alt: 'Browser site permissions for camera and microphone',
            caption:
              'Open the settings icon in the URL and ensure Microphone is allowed.',
          },
        ],
      },
      {
        id: 'voice-breaking',
        question: 'My voice is breaking up',
        blocks: [
          {
            type: 'paragraph',
            text: 'Voice breakup is almost always a network problem.',
          },
          {
            type: 'list',
            items: [
              'Check your internet speed and stability',
              'Look at the signal indicator in the class header. If it is yellow or red, switch networks.',
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'video',
    title: 'Video Issues',
    emoji: '📹',
    items: [
      {
        id: 'camera-not-working',
        question: "My camera isn't working",
        blocks: [
          {
            type: 'list',
            ordered: true,
            items: [
              'Allow camera permission when prompted. If denied earlier, fix via the settings in the address bar.',
              'Close other apps that might be using the camera (Zoom desktop, Google Meet, OBS).',
              'Reload the page after granting permission — some browsers need a refresh.',
              'Also make sure your parental controls are not blocking the camera, if so ask your parents to unblock it.'
            ],
          },
          {
            type: 'image',
            src: require('@/Assets/Images/Help/Classroom/permissions.png'),
            alt: 'Browser site permissions for camera and microphone',
            caption:
              'Open the settings icon in the URL and ensure Camera is allowed.',
          },
        ],
      },
      
    ],
  },
  {
    id: 'connectivity',
    title: 'Connectivity Issues',
    emoji: '📡',
    items: [
      {
        id: 'stuck-joining',
        question: "Stuck on 'Joining…' or 'Waiting for the host'",
        blocks: [
          {
            type: 'list',
            ordered: true,
            items: [
              'Try switching networks (Wi-Fi → mobile hotspot, or vice versa).',
              'Confirm the class start time. Coaches sometimes join 1–2 minutes late.',
              'Wait 3–5 minutes after the scheduled time before assuming something is wrong.',
              'Reload the page with Ctrl+Shift+R (Windows) or Cmd+Shift+R (Mac).',     
            ],
          },
        ],
      },
      {
        id: 'firewall',
        question: 'My school or office network is blocking Zoom',
        blocks: [
          {
            type: 'list',
            items: [
              'Try a free VPN (Proton VPN, Windscribe). Connect to any server, then rejoin.',
              'On work or school networks, ask IT to whitelist Zoom domains.',
              "Quick workaround: turn on your phone's hotspot and connect your laptop to it.",
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'other',
    title: 'Other Issues',
    emoji: '🧩',
    items: [
      {
        id: 'puzzle-cant-move',
        question: "I can't move pieces in an active puzzle",
        blocks: [
          {
            type: 'list',
            ordered: true,
            items: [
              "Make sure you joined via the 'Join' button (not in zoom directly).",
              'Check the puzzle timer — if it reads 0, wait for the next puzzle.',
              'Refresh the page if the timer is running but pieces are frozen.',
            ],
          },
        ],
      },
      {
        id: 'leaderboard-missing',
        question: "I'm not shown on the leaderboard",
        blocks: [
          {
            type: 'list',
            items: [
              "The leaderboard shows the top 10. If you're outside the top 10, that is expected.",
              'Solve at least one puzzle correctly without a hint to count for ranking.',
            ],
          },
        ],
      },
      {
        id: 'solved-with-hint',
        question: "What does 'Solved with Hint' mean?",
        blocks: [
          {
            type: 'paragraph',
            text: 'You made at least one wrong move before solving — the system marked it as hint-assisted.',
          },
        ],
      },
      {
        id: 'change-name',
        question: 'How do I change my display name?',
        blocks: [
          {
            type: 'paragraph',
            text: 'Update your name in your Profile section. The change is permanent across all future classes.',
          },
        ],
      },
      {
        id: 'black-screen',
        question: 'I see a black screen instead of the coach',
        blocks: [
          {
            type: 'paragraph',
            text: "This usually means you clicked 'Leave' during or after class.",
          },
          {
            type: 'list',
            items: [
              "Click 'Join' again from the Meetings tab.",
              'If the class is still running, re-entering will restore video.',
            ],
          },
        ],
      },
      {
        id: 'full-screen',
        question: 'How do I go full screen?',
        blocks: [
          {
            type: 'list',
            items: [
              "Top-right of the coach screen → 'Full Screen' button.",
              "If you don't see it, click 'View' first — the option is inside.",
            ],
          },
        ],
      },
      {
        id: 'screen-share',
        question: 'Screen sharing not working',
        blocks: [
          {
            type: 'list',
            items: [
              'Screen share works on laptop and desktop browsers only.',
              'It is not supported on the Caissa app or iPads, tablets via the Caissa website.',
              'On mobile or tablet, use the Zoom app instead[if necessary]',
            ],
          },
        ],
      },
      {
        id: 'still-stuck',
        question: 'Still stuck?',
        blocks: [
          {
            type: 'paragraph',
            text: "Use the 'Raise an issue' button or contact the CSM team for assistance.",
          },
        ],
      },
    ],
  },
];
